var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicantWithArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7554 4.90547C5.7554 3.19594 7.14125 1.81009 8.85078 1.81009C10.5603 1.81009 11.9462 3.19594 11.9462 4.90547C11.9462 6.615 10.5603 8.00086 8.85078 8.00086C7.14125 8.00086 5.7554 6.615 5.7554 4.90547ZM8.85078 0.9C6.63862 0.9 4.84531 2.69331 4.84531 4.90547C4.84531 7.11763 6.63862 8.91094 8.85078 8.91094C11.0629 8.91094 12.8563 7.11763 12.8563 4.90547C12.8563 2.69331 11.0629 0.9 8.85078 0.9Z",
    fill: "#787395",
    stroke: "#787395",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.4995C20 13.6933 19.9325 13.8808 19.82 13.9996L18.02 15.875C17.939 15.9562 17.8445 16 17.75 16C17.6825 16 17.6105 15.975 17.5475 15.9312C17.3945 15.825 17.3 15.6124 17.3 15.3749V14.1246H11.45C11.2025 14.1246 11 13.8433 11 13.4995C11 13.1557 11.2025 12.8744 11.45 12.8744H17.3V11.6241C17.3 11.3866 17.3945 11.1678 17.5475 11.0677C17.7005 10.9615 17.885 10.9802 18.02 11.124L19.82 12.9994C19.9325 13.1182 20 13.3057 20 13.4995Z",
    fill: "#787395"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11C11 9.5 1.4 8.9 1 16.5",
    stroke: "#787395",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16.5H15.5",
    stroke: "#787395",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicantWithArrow);
export default __webpack_public_path__ + "static/media/applicant-with-arrow.0c3aba87.svg";
export { ForwardRef as ReactComponent };